<!--
 * @Author: gongzhichao
 * @Date: 2023-05-24 17:20:00
 * @LastEditors: gongzhichao 18311120024@163.com
 * @Description: 面包屑导航组件 -- 移动端
-->
<template>
  <div class="main">
    <div class="breadcrumb">
      <img
        class="back"
        src="../../../../assets/image/mb/icon-breadcrumb.png"
        @click="back"
        alt
      />
      <div class="nav">
        <el-breadcrumb
          class="new-breadcrumb"
          separator-class="el-icon-arrow-right"
        >
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item
            :to="{ path, query: { title: $route.query.path } }"
            v-if="$route.query.path"
          >
            <div class="breadcrumb-item">{{ $route.query.path }}</div>
          </el-breadcrumb-item>
          <!-- <el-breadcrumb-item>{{$route.query.title}}</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
    </div>
    <!-- <div class="top-bg"></div> -->
  </div>
</template>

<script>
export default {
  computed: {
    path() {
      return this.$route.query.path == "游戏资料"
        ? "/information"
        : "/newspaper";
    },
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.breadcrumb {
  display: flex;
  align-items: center;
  height: 50px;
  width: 350px;
  z-index: 999;
  margin-top: 35px;
  border-bottom: 1px solid #cdba9f;
  .back {
    width: 15px;
    height: 15px;
    margin-left: 15px;
  }
  .nav {
    margin-left: 10px;

    /deep/ .new-breadcrumb {
      .el-breadcrumb__inner.is-link,
      .el-breadcrumb__inner a {
        font-weight: 500 !important;
        color: #8c5d26;
      }
      .breadcrumb-item {
        max-width: 150px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    i {
      margin: 0 10px;
    }
    a {
      font-weight: normal;
    }
  }
}
.top-bg {
  width: 100%;
  height: 150px;
  background-size: 100% 100%;
  overflow: hidden;
  z-index: 998;
}
</style>
